import React from 'react'

function NonReturnDamper() {
  return (
    <embed src="\pdfs\E2.4_rk-e20_07.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default NonReturnDamper